// import { HVIcon } from "@repo/HVComponents";
import { IconArrowRight } from "@resources/icons/Icons";
import { TreeViewCollapseBtnProps } from "./Interfaces";
import * as S from "./TreeViewCollapse.styled";

const TreeViewCollapseBtn = ({
  isLeaf,
  disabled,
  expanded,
  onExpanded
}: TreeViewCollapseBtnProps) => {
  if (isLeaf) {
    return (
      <S.TreeViewCollapseBtnStyled>
        <span className="tree-view-icon" />
      </S.TreeViewCollapseBtnStyled>
    );
  }

  return (
    <S.TreeViewCollapseBtnStyled>
      <button
        type="button"
        className={`collapse-btn ${expanded && "expaneded"}`}
        disabled={disabled}
        onClick={() => onExpanded()}
        aria-label="button arrow up"
      >
        <IconArrowRight />
        {/* <HVIcon name="arrow-chevron-right" svgProps={{ ...ICON.SIZE_24 }} /> */}
        {/* this should be change to HVIcon. HVIcon is working now so please change it later. */}
      </button>
    </S.TreeViewCollapseBtnStyled>
  );
};

export default TreeViewCollapseBtn;
